module.exports = __webpack_public_path__ + "static/img/pic_fail.8be26521.png";